import { css } from '@emotion/react';

export const sharedStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 2.5px;
  height: 40px;
  margin: 30px 0;
`;

export const sharedBoxShadow = css`
  box-shadow: 0 3px 3px #00000029;
`;

export const sharedFontStyle = css`
  font-size: large;
  font-weight: bold;
`;
